import { type LogoProps } from '../registry';

export function TeeUpIndoorGolfDarkLogo({
  width = 120,
  height = 120,
  className = 'h-auto max-w-full',
  ariaHidden = true,
  viewBox,
}: LogoProps) {
  return (
    <svg
      id="teeupindoorgolf-dark-logo-layer"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox ?? '0 0 120 120'}
      width={width}
      height={height}
      className={className}
      aria-hidden={ariaHidden}
    >
      <g
        fill="#fff"
        fillRule="evenodd"
        clipPath="url(#teeupindoorgolf-dark_svg__a)"
        clipRule="evenodd"
      >
        <path d="M0 60a59.998 59.998 0 0 0 102.426 42.426 59.995 59.995 0 0 0 0-84.852A59.998 59.998 0 0 0 0 60m3.986 0a56.014 56.014 0 1 0 112.028 0A56.014 56.014 0 0 0 3.986 60" />
        <path d="M60.03 19.756 25.442 46.78v42.15h31.305V74.567l-9.732-9.497v-3.107l25.97-.059.059 3.166-9.732 9.497v23.86l9.732-9.498h21.573V46.78zM46.459 44.64a13.571 13.571 0 1 0 27.142 0 13.571 13.571 0 0 0-27.142 0" />
      </g>
      <defs>
        <clipPath id="teeupindoorgolf-dark_svg__a">
          <path fill="#fff" d="M0 0h120v120H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
